import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';

const AdminLayout = ({ onLogout }) => {
    return (
        <div style={{ display: 'flex', minHeight: '100vh', background: '#f3f4f6' }}>
            <AdminSidebar onLogout={onLogout} />
            {/* minWidth: 0 is required here — a flex item defaults to min-width:auto, so without it
                this panel grows to fit wide children (tables, filter rows) instead of shrinking,
                and the WHOLE page scrolls horizontally on small screens instead of just the
                table/filter content that actually needs it. */}
            <div style={{ flex: 1, minWidth: 0, marginLeft: '260px', padding: '32px', overflowX: 'hidden' }}>
                <Outlet />
            </div>
        </div>
    );
};

export default AdminLayout;
